export default "__VITE_ASSET__BYnSB2Sd__"